import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { BaseCellRendererProps } from '../Common/CellRendererProps';

export const NumberCellRenderer: React.FC<BaseCellRendererProps> = (props) => {
  const [value, setValue] = useState<number>(props.value || 0);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(event.target.value) || 0;
    setValue(newValue);
    props.node.setDataValue(props.column.colId, newValue);
  };

  const handleBlur = () => {
    if (props.context?.onCellUpdate) {
      props.context.onCellUpdate(props.data, props.column.colId, value);
    }
  };

  return (
    <TextField
      size="small"
      type="number"
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      variant="outlined"
      fullWidth
    />
  );
};